export default __webpack_public_path__ + "static/media/fireflink-white-logo.02f6222e.png";